import { Button, CircularProgress, makeStyles, Theme } from '@freighthub/silhouette-core'
import { CSSProperties, FC } from 'react'
import { useI18n } from 'utils/localisation'

export const testIds = { loadMore: 'load-more', circularProgress: 'load-more_circular-progress' }

type LoadMoreProps = {
  loadMore: () => void
  isLoading: boolean
  containerStyle?: CSSProperties
}

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: theme.spacing(3.5, 0),
    position: 'absolute',
    bottom: theme.spacing(-15),
    width: '100%',
  },
  refreshIndicatorContainer: {
    display: 'inline-block',
    position: 'relative',
    margin: theme.spacing(0, 'auto'),
  },
}))

export const LoadMore: FC<LoadMoreProps> = ({ containerStyle, isLoading, loadMore }) => {
  const { translate } = useI18n()
  const classes = useStyles()
  return (
    <div style={containerStyle} className={classes.container}>
      {!isLoading ? (
        <Button onClick={loadMore} variant="contained" data-testid={testIds.loadMore}>
          {translate('activity-feed_load_more')}
        </Button>
      ) : (
        <div className={classes.refreshIndicatorContainer} data-testid={testIds.circularProgress}>
          <CircularProgress size={56} />
        </div>
      )}
    </div>
  )
}
